import {
    Box,
    Button,
    HStack,
    Stack,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Optional } from "../../components/Form";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import {
    AccountSubscription,
    ClientProfile,
    InsurancePolicyHolderSubscriptionAuthorization,
    ParticipantRole,
    TierCardHolderSubscriptionAuthorization,
    TierCodeType,
    useAccountSubscriptionQuery,
    useSubscriptions2CsvMutation
} from "../../graphql";

import { useDashboardTitle } from "../../hooks/useDashboardTitle";
import { formatDateTime } from "../../utils";
import { getSubscriptionStatus } from "../Subscriptions/subscriptions";

export const getSubscriptionMethod = (
    authorization: Optional<AccountSubscription["authorization"]>
) => {
    if (
        authorization.__typename ===
    "InsurancePolicyHolderSubscriptionAuthorization"
    ) {
        return "Policë sigurimi";
    }

    if (authorization.__typename === "TierCardHolderSubscriptionAuthorization") {
        if (authorization.tierCode?.type === TierCodeType.Card) {
            return "Kartë";
        }

        return "Nga sistemi";
    }
};

export const SubscriptionInfo: React.FC<{ id: number }> = ({ id }) => {
    const { data, loading } = useAccountSubscriptionQuery({
        variables: {
            id: id
        }
    });

    const subscription = data?.subscription;

    if (loading || !subscription) {
        return <Loader />;
    }

    return (
        <>
            <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
                <Table variant="simple">
                    <Thead>
                        <Tr>
                            <Th isNumeric width="40%"></Th>
                            <Th width="50%"></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        <Tr>
                            <Td isNumeric>Klienti</Td>
                            <Td>
                                <Link to={ `/account/${subscription.account.id}` }>
                                    <AccountAvatar
                                        key={ subscription?.account?.id }
                                        account={ subscription?.account }
                                        size="xs"
                                        role={ false }
                                    />
                                </Link>
                            </Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Paketa</Td>
                            <Td>{ subscription.authorization.tier.name }</Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Fillimi</Td>
                            <Td>{ formatDateTime(subscription.startDate) }</Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Përfundimi</Td>
                            <Td>{ formatDateTime(subscription.expirationDate) }</Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Statusi</Td>
                            <Td>{ getSubscriptionStatus(subscription) }</Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Metoda</Td>
                            <Td>{ getSubscriptionMethod(subscription.authorization) }</Td>
                        </Tr>
                        { subscription.authorization.__typename ===
            "InsurancePolicyHolderSubscriptionAuthorization" ? (
                <>
                                    <Tr>
                        <Td isNumeric>Polica</Td>
                        <Td>
                                            {
                                                (subscription.authorization as InsurancePolicyHolderSubscriptionAuthorization)
                                                    .insurancePolicy.name
                                            }
                                        </Td>
                    </Tr>
                                    <Tr>
                        <Td isNumeric>Kodi</Td>
                        <Td>
                                            {
                                                (subscription.authorization as InsurancePolicyHolderSubscriptionAuthorization)
                                                    .insurancePolicySerialNumber
                                            }
                                        </Td>
                    </Tr>
                                </>
                            ) : null }
                        { subscription.authorization.__typename ===
            "TierCardHolderSubscriptionAuthorization" ? (
                <>
                                    <Tr>
                        <Td isNumeric>Kodi</Td>
                        <Td>
                                            {
                                                (subscription.authorization as TierCardHolderSubscriptionAuthorization)
                                                    .tierCode.code
                                            }
                                        </Td>
                    </Tr>
                                    <Tr>
                        <Td isNumeric>Pagesa</Td>
                        <Td>
                                            {
                                                (subscription.authorization as TierCardHolderSubscriptionAuthorization)
                                                    .payment.amount
                                            }
                                        </Td>
                    </Tr>
                                </>
                            ) : null }
                        <Tr>
                            <Td isNumeric>Data e lëshimit</Td>
                            <Td>{ formatDateTime(subscription.authorization.createdAt) }</Td>
                        </Tr>
                    </Tbody>
                </Table>
            </Box>
        </>
    );
};

export const Subscription: React.FC = () => {
    // const { setTitle } = useDashboardTitle();

    const { id } = useParams<{ id: string }>();

    // useEffect(() => {
    //   if (!loading) {
    //     setTitle([
    //       {
    //         to: `/subscriptions`,
    //         text: "Abonime",
    //       },
    //       `${(subscription.account.profile as ClientProfile).name} ${
    //         (subscription.account.profile as ClientProfile).lastname
    //       } ${formatDateTime(subscription.startDate)}`,
    //     ]);
    //   }
    //   // eslint-disable-next-line
    // }, []);

    return <SubscriptionInfo id={ parseInt(id) } />;
};
